import { DefaultValues, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAlert } from 'shared/components/alerts/use-alert';
import { useTranslation } from 'react-i18next';
import { useUploadCertificates } from './use-upload-certificates';
import { AccreditationType } from './types';
import { certificateUploadSchema } from '../schema';
import { CertificateUploadFormValues } from '../types';

const DEFAULT_VALUES: DefaultValues<CertificateUploadFormValues> = {
  accreditationType: undefined,
  certificate: undefined,
  certificateFile: undefined,
  termsAndConditionsAccepted: false,
  email: '',
};

export function useCertificateUploadForm() {
  const form = useForm<CertificateUploadFormValues>({
    resolver: zodResolver(certificateUploadSchema),
    defaultValues: DEFAULT_VALUES,
    mode: 'onChange',
  });

  const { mutate: uploadCertificates } = useUploadCertificates();
  const { alertSuccess, alertError } = useAlert();
  const { t } = useTranslation('web-common');

  const onSubmit = (data: CertificateUploadFormValues) => {
    uploadCertificates(
      {
        accreditationType: data.accreditationType as AccreditationType,
        certificate: data.certificate,
        files: data.certificateFile,
        email: data.email,
      },
      {
        onSuccess: () => {
          form.resetField('certificate');
          form.resetField('certificateFile');
          form.resetField('accreditationType');
          alertSuccess(t('upload-certificate-screen.form.success-message'));
        },
        onError: (error) => {
          alertError(error);
        },
      }
    );
  };

  return { form, onSubmit };
}
